import styles from './ContextMenu.module.css';

export type ContextMenuHeaderProps = {
  title: string;
  /** Моноширинный хвост: код проекта (68:65) или перечень проектов выделения (68:5). */
  hint?: string;
};

/**
 * Шапка меню — не пункт: не фокусируется, не выбирается (макет 68:63 / 68:3).
 */
export function ContextMenuHeader({ title, hint }: ContextMenuHeaderProps): JSX.Element {
  return (
    <div className={styles.header}>
      <span className={styles.headerTitle}>{title}</span>
      {hint && <span className={styles.headerHint}>{hint}</span>}
    </div>
  );
}
